import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

const BusinessContext = createContext();

export function BusinessProvider({ children }) {
  const [businessName, setBusinessName] = useState('it IN A bit');
  const [loading, setLoading] = useState(true);
  const [businessTimezone, setBusinessTimezone] = useState(undefined);

  useEffect(() => {
    fetchBusinessName();
  }, []);

  const fetchBusinessName = async () => {
    try {
      const response = await axios.get(`${API}/settings/business`);
      setBusinessName(response.data.business_name);
      setBusinessTimezone(response.data.timezone);
    } catch (error) {
      console.error('Failed to fetch business name:', error);
      setBusinessName('it IN A bit'); // Fallback
    } finally {
      setLoading(false);
    }
  };

  return (
    <BusinessContext.Provider value={{ businessName, businessTimezone, loading, refreshBusinessName: fetchBusinessName }}>
      {children}
    </BusinessContext.Provider>
  );
}

export function useBusinessName() {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusinessName must be used within BusinessProvider');
  }
  return context;
}
